import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';
var SmartHome = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return (<g id={'contour'}>
            <path d='M11.4 21.8101H17.6C19.03 21.8101 20.4 20.65 20.64 19.24L21.97 11.28C22.13 10.3 21.63 8.99002 20.86
             8.37002L13.93 2.82998C12.86 1.96998 11.13 1.96997 10.07 2.81997L3.14004 8.37002C2.36004 8.99002 1.86002 10.3
             2.03002 11.28L2.31002 12.96' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M2 19C3.76 19.04 4.96 20.24 5 22' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M8 22C7.99 21.24 7.86 20.53 7.63 19.88C7.04 18.21 5.78 16.96 4.12 16.37C3.47 16.14 2.76 16.01 2 16' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M1.9955 22H2.0045' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>);
};
export default createSvg(SmartHome, 'smart-home');
